import React from "react";

import Avatar from "../Avatar";
import * as Styled from "./AvatarsCollection.styled";

const AvatarsCollection = ({ avatars, limit = 5 }) => {
  if (!avatars?.length) {
    return <Avatar />;
  }

  const avatarsToShow = avatars.slice(0, limit);
  const count = avatars?.length - limit || 0;

  return (
    <Styled.AvatarsCollection>
      {avatarsToShow.map((avatar) => (
        <li key={avatar.id || avatar.value}>
          <Avatar
            name={avatar.userName || avatar.label}
            picture={avatar.profilePicture || avatar.picture}
          />
        </li>
      ))}
      {count > 0 ? <Styled.Count>+{count}</Styled.Count> : null}
    </Styled.AvatarsCollection>
  );
};

export default AvatarsCollection;
